/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./option.component";
var styles_UIOptionComponent = [];
var RenderType_UIOptionComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_UIOptionComponent, data: {} });
export { RenderType_UIOptionComponent as RenderType_UIOptionComponent };
export function View_UIOptionComponent_0(_l) { return i0.ɵvid(0, [i0.ɵncd(null, 0)], null, null); }
export function View_UIOptionComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ui-option", [], [[2, "selected", null]], [[null, "click"]], function (_v, en, $event) { var ad = true; if (("click" === en)) {
        var pd_0 = (i0.ɵnov(_v, 1).selectOption() !== false);
        ad = (pd_0 && ad);
    } return ad; }, View_UIOptionComponent_0, RenderType_UIOptionComponent)), i0.ɵdid(1, 49152, null, 0, i1.UIOptionComponent, [i0.ElementRef], null, null)], null, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).selected; _ck(_v, 0, 0, currVal_0); }); }
var UIOptionComponentNgFactory = i0.ɵccf("ui-option", i1.UIOptionComponent, View_UIOptionComponent_Host_0, { disabled: "disabled", value: "value" }, { onSelectOption: "onSelectOption" }, ["*"]);
export { UIOptionComponentNgFactory as UIOptionComponentNgFactory };
